import React from 'react';
import {LauncherComponentBase} from '../../base-components/launcher-component-base';
import {NumericValueEditorComponent} from '../numeric-value-editor/numeric-value-editor.component';
import {DropDownValueEditorComponent} from '../drop-down-value-editor/drop-down-value-editor.component';
import {NumericDropDownItem} from '../../../services/configurations-areas/fields-definitions/numeric-drop-down-field-definition';
import {observer} from 'mobx-react';
import {IConfigFieldDefinition} from '../../../services/configurations-areas/fields-definitions/config-field-definition-base';



export interface NumericDropDownValueEditorComponentProps {
    fieldDefinition: IConfigFieldDefinition;
    items: NumericDropDownItem[];
}

@observer
export class NumericDropDownValueEditorComponent extends LauncherComponentBase<NumericDropDownValueEditorComponentProps> {
    private _renderOtherValueInput = (): React.ReactNode  =>  {
        return (<NumericValueEditorComponent fieldDefinition={this.props.fieldDefinition} placeholder={`Other ${this.props.fieldDefinition.title}`} />);
    };

    render() {
        return (
            <DropDownValueEditorComponent fieldDefinition={this.props.fieldDefinition}
                                          items={this.props.items}
                                          renderOtherValueInput={this._renderOtherValueInput}/>
        )
    }
}